import { StateStore } from '@client:common/state-store';
import { Theme } from '@client:common/Theme';

import { GlobalState } from './GlobalState';

/**
 * A global state store that is visible to all modules in the application. Global state store
 * should not know about any feature module specific details, in other words, feature modules
 * can import this global state store, but the other way around is prohibited, this one-directional
 * relationship creates a very nice decoupling that makes it easy to maintain.
 */
export class GlobalStore extends StateStore<GlobalState> {
  private static readonly _INSTANCE_ = new GlobalStore();

  static getInstance() {
    return GlobalStore._INSTANCE_;
  }

  private constructor() {
    super();
  }

  getInitialState(): GlobalState {
    return {
      authenticatedAccount: null,
      currentTheme: (localStorage.getItem('theme') as Theme) || Theme.DARK,
      isAssistantFullScreen: false,
      assistantPositionOverride: null
    };
  }
}
